import { createContext, useReducer } from "react";
import githubReducer from "../GithubReducer";

//create invironmental variable
const GithubContext = createContext()

//get the invironmental var from the provided address
const GITHUB_URL = `https://api.github.com/search/users?`;


//export a provider function, which provides children
//create intial state and set it to an object 
export const GithubProvider = ({children}) => {
  const initialState = {
    users: [],
    user: {},
    loading: false,
  }
  //distructure from an array and dispatch it under fetchusers function
  const [state, dispatch] = useReducer(githubReducer, initialState)


  //Get search results
  const searchUsers = async (text) => {
    //call set laoding function below
    setLoading()

    const params = new URLSearchParams({
        q: text
    })

    const response = await fetch(`${GITHUB_URL}${params}`)

    const {items} = await response.json()

    dispatch({
        //dipatch takes in an action object, and dispatches it to github reducer
        //the type is a string and has to be upper case
        type: 'GET_USERS',
        //payload is the data that we get from API
        payload: items,
    })
  }
  //Get single search results
  const getUser = async (login) => {
    //call set laoding function below
    setLoading()

    const response = await fetch(`${GITHUB_URL}/users/${login}`)

    if(response.status === 404) {
      window.location = '/notfound'
    } else {

      const {data} = await response.json()
  
      dispatch({
          //dipatch takes in an action object, and dispatches it to github reducer
          //the type is a string and has to be upper case
          type: 'GET_USER',
          //payload is the data that we get from API
          payload: data,
      })
    }

  }


  // Clear users from the state
  const clearUsers = () => dispatch({
    type: 'CLEAR_USERS'
  })



  // create a function for Set loading that dispatch an object type set laoding
  const setLoading = () => dispatch({type:
  'SET_LOADING'
  })



  //return from githubContext.ptovider, which is the children thats passed in
  return (
  <GithubContext.Provider 
    value={{
        //the dispatch is updating the state, so pass the components below
        users: state.users,
        loading: state.loading,
        user: state.user,
        searchUsers,
        clearUsers,
        getUser

    }} >
        {children}
  </GithubContext.Provider>
  )
}

export default GithubContext